import { ArrowRight, FileSignature } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "../shared/Badge";
import content from "../../data/content.json";

const { hero } = content.home;
const STATS = hero.stats;

export function HomeHero() {
  return (
    <section data-testid="home-hero" className="relative overflow-hidden border-b border-slate-800">
      <div aria-hidden="true" className="grid-bg pointer-events-none absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
        <div className="fade-up max-w-3xl">
          <Badge testId="home-hero-badge"><FileSignature aria-hidden="true" className="h-3.5 w-3.5" />{hero.badge}</Badge>
          <h1 data-testid="home-hero-title" className="mt-6 text-4xl font-semibold leading-[1.08] tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">
            {hero.title}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">
            {hero.subtitle}
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row">
            <Link to="/#solucoes" data-testid="home-hero-cta-solutions" className="btn-primary">
              Conhecer soluções <ArrowRight aria-hidden="true" className="h-4 w-4" />
            </Link>
            <Link to="/#seguranca" data-testid="home-hero-cta-security" className="btn-secondary">
              Segurança e LGPD
            </Link>
          </div>
        </div>
        <dl className="fade-up-delay mt-16 grid gap-px overflow-hidden rounded-md border border-slate-800 bg-slate-800 sm:grid-cols-3">
          {STATS.map((s) => (
            <div key={s.k} className="bg-slate-950 p-6">
              <dt className="font-mono text-[11px] uppercase tracking-[0.18em] text-emerald-500">{s.k}</dt>
              <dd className="mt-2 text-sm text-slate-300">{s.v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
